import { Dictionary, Vocabulary } from "../Dictionary"

// want a truly 'common' or plain language...
// much closer to middle (or even contemporary)
// . still poetic/whimsical/dramatic/etc)
const commonVocabulary: Vocabulary = {
  heat: 'hete',
  cold: 'cold',
  cloud: 'cloud', //'pall',
  cloudy: 'cloudy', //'pallid', //clouded',
  daisy: 'woundwort',
  dandelion: 'puffball',
  dragons: 'drake',
  dark: 'derk',
  island: 'ylond',
  abundant: 'abounding',
  afternoon: 'overnoon',
  apple: 'pome',
  autumn: 'fall', 

  awe: 'wonder', //awe',
  battle: 'batell',
  bay: 'bay', //'-iâ',
  bears: 'bera', //bruin',
  beautiful: 'lovesome',
  bell: 'belle', //bell',
  birch: 'birce',
  birds: 'bord',

  bitter: 'bittre',
  // 'murk' in the sense of absorbing all light
  black: 'merk-', //'blake-', //black',
  blood: 'blood',
  blue: 'blew', //blaw',
  bold: 'bolt',
  bread: 'bred', //bread',
  candle: 'candel',
  cherry: 'cherie', // cherry',
  citadel: 'city-hold', // burhfæsten', //city',
  claws: 'clawe',
  day: 'daye', //day',
  deep: 'deepe', //deopnes',
  dew: 'deaw',
  divine: 'gode', //divin',
  // dragons: 'fýrdraca', //wyrm //sky-serpent',
  dread: 'drede', //ghastly',
  dream: 'dreame',
  dusk: 'eventide',
  dusty: 'dusti',

  eagles: 'egle',
  earth: 'erthe',
  elderberry: 'elder',
  elephants: 'olifant',
  elm: 'elme', //wahu',

  evening: 'evenyng', //dim',
  fangs: 'fangtooth',
  fate: 'doom', //fate',
  fell: 'fellen', // deadly
  fire: 'fier', //'fȳr', //fier', //bæl', //fire', //'naur-',
  firmament: 'heven', //heavens',
  fish: 'fisch',
  foe: 'faman', //enemy',
  forest: 'foreste',
  fortress: 'holden',
  fortunate: 'lukky', //lucky',
  freedom: 'freodom',
  friend: 'frēond', //friend',
  frost: 'ryme',//forst',
  giant: 'giaunt', // colossus',
  glen: 'gleann', // dell
  gloom: 'gloam',
  gold: 'gold',
  golden: 'gulden',
  gray: 'grey',
  great: 'great',
  green: 'gre',

  harbor: 'hyth',
  haven: '-havene', //port',
  hill: '-hyll', // tun
  holy: 'hāliġ',
  honey: 'huniġ',
  horns: 'horne',
  horror: 'fyrhtu',
  horses: 'eoh',

  ice: 'is-',
  iron: 'iren-',
  isle: 'yl-', //'īegland', //island',

  jewel: 'jeuel',
  journey: 'journe',
  joy: 'joye', //ġefēa', //joy',
  king: 'kenning',
  kingdom: 'kenningdom',
  laughter: 'laughtre',
  lake: 'lac',
  land: '-land', //eäth',
  large: 'larc', //grand',
  light: 'lighte',
  lily: 'lilly',
  lofty: 'lofte',
  lonely: 'lone',

  lord: 'lord', //-lord',

  love: 'love',
  magic: 'magyk', //charm',
  mantle: '-cloke', //mantel',
  midnight: 'midnyght',
  mist: '-fog',
  moon: 'mone', // 'mōna',
  morning: '-morn',
  mound: '-hyll',
  mountain: 'mount',
  music: 'musika', //dréamcræft', //-song',

  narrow: 'narrowe',//narrow-',
  needle: 'nedle', //needle',
  night: 'nyght',
  nightingales: 'thrush', //stærlinc', //thrush',
  noon: 'noon',

  oak: 'oak',
  orange: 'orenge',

  pale: 'bleek-',
  path: 'peth', //brimlad',
  peak: 'peek', // see point, needle
  peoples: '-folk',
  pine: 'pyne',
  place: '-stead',//bídung', //place',
  point: '-point',
  pool: '-pole', //mere',
  poppy: 'celandine',
  prison: 'gaole', //'prisoun', // gaol', // 'carcern'

  quick: 'quic',
  rain: 'rain',
  rainbow: 'rainbow',

  realm: 'ward', // -ríce', //ward',
  red: 'reod-',
  region: '-regioun', //guard',
  river: 'ryver',
  road: 'rode',
  rose: 'rose',

  sea: 'see', //estmere', //'mer',
  secret: 'secrette', //secret', //secret',
  shade: 'shade',
  shadow: 'schadowe', //shadow', //sceaduwe', //shadow', // 'gwath', //dûl',
  sharp: 'sharp',
  ship: 'shippe',
  silence: 'stilnes', //silence',
  silver: 'argent', // 'sulver',
  skill: 'skille', //searu',
  sky: 'skie', //'heaven', //sky',
  slave: 'thralle',
  small: 'smal',
  smith: '-wright',
  snakes: 'addere', //serpent',
  snow: 'snow', //snow-',
  sorrow: 'sorwe',
  spark: 'sparke', //ysl', //spark-',
  sparkling: 'glitre',
  speech: 'speche', //speech*',
  spirit: 'gāst-',
  splendid: 'splendur', //from', //splendid-',
  spring: 'springen',
  spruce: 'spruse',
  starlight: 'sterrelighte',
  stars: '-sterre', //star',
  stream: 'strēam', //river',
  stronghold: '-stranghalde',
  summer: '-sumer', //aer',
  sun: 'sun',
  swans: 'swan', //swane',
  sweet: 'sweete', //sweet',

  tall: "-talle", // brant-", //nd-",
  tears: 'cryinge', //tears',
  thought: 'thoughte', //thought*',
  tin: 'tin',
  tiny: 'tyny',
  tomorrow: 'tomorwe',
  tower: 'torr-',
  treasure: 'tresour',
  tyranny: 'tirranye', //mánbealu',

  valley: 'valeye', //'dæl', //vale',
  veil: 'veyl', //veil',
  water: 'watir',
  wax: 'waxe',
  white: 'hwit', // hwit
  wide: 'wyd',
  willow: 'willow',
  wind: 'wynd-',
  wine: '-wyn',
  winter: 'wintre',
  holly: 'holi-',
  garden: 'gardyn', //garden',
  queen: 'cwen', //queen',
  prince: 'prince',
  princess: 'princess',
  hounds: 'hound',
  wolves: 'wolf',
  embers: 'embre', //embers',
  soot: 'soote', //soot',
  ash: 'ash',
  salt: 'salt',
  void: 'voide', //space',
  steam: 'steem',
  magma: 'lava',
  radiance: 'gleam', //brilliance',

  '-less': 'no-',
  'ever-': 'even-', // 'ever-dusk' --> evendim
  'at-': 'by--',

  // fem/masculine suffices
  '-person': '-persoun',
  '-man': '-man',
  '-son': '-sonn',

  '-woman': '-weoman',
  '-maid': '-mayden', //maid',
  '-daughter': '-doughter',
  
  'mountain-chain': ' mountayne', //mountains',
}

const Common = new Dictionary("Common", commonVocabulary)
export default Common
